import React from 'react';
import { Link } from 'react-router';

import './listcomponent.css';

const PhotographerComponent = ({ data, title }) => (
  <section className="o-list">
    <h1 className="o-list-header f3 db">{title}</h1>
    <ul className="m-list">
      {data.map(p => (
        <li key={p.id} className="m-list-result">
          <Link to={p.url}>
            {p.leftIcon && <i className={p.leftIcon} />}
            <span className="a-list-result-title">{p.title}</span>
            {p.subtext && (
              <span className="a-list-result-subtext">{p.subtext}</span>
            )}
          </Link>
        </li>
      ))}
    </ul>
  </section>
);

export default PhotographerComponent;



// WEBPACK FOOTER //
// ./src/pages/ListComponent.js